@file:OptIn(InternalResourceApi::class)

package timbrebahia.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/timbrebahia.shared.generated.resources/"

@delegate:ResourceContentHash(-110_492_271)
internal val Res.drawable.clear: DrawableResource by lazy {
      DrawableResource("drawable:clear", setOf(
        ResourceItem(setOf(), "${MD}drawable/clear.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_106_122_633)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-957_195_724)
internal val Res.drawable.logout: DrawableResource by lazy {
      DrawableResource("drawable:logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/logout.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_560_536_093)
internal val Res.drawable.visibility: DrawableResource by lazy {
      DrawableResource("drawable:visibility", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_896_715_579)
internal val Res.drawable.visibility_off: DrawableResource by lazy {
      DrawableResource("drawable:visibility_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/visibility_off.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("clear", Res.drawable.clear)
  map.put("logo", Res.drawable.logo)
  map.put("logout", Res.drawable.logout)
  map.put("visibility", Res.drawable.visibility)
  map.put("visibility_off", Res.drawable.visibility_off)
}
